import React from "react";

import Icon from "./Icon";
import Modal from "./Modal";

const SkillCard = ({ active, description, disabled, icon, label, onClick, proTag }) => (
  <button
    className="btn btn-block btn-default play-options-skill-btn"
    disabled={disabled}
    onClick={onClick}
    style={{
      textAlign: "left",
      padding: "12px 15px",
      marginBottom: 8,
      opacity: disabled ? 0.5 : 1,
      borderWidth: 2,
      borderColor: active ? "#5cb85c" : undefined,
      background: active ? "rgba(92, 184, 92, 0.1)" : "none",
      boxShadow: "none"
    }}
    type="button"
  >
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <Icon name={icon} style={{ fontSize: 18, color: active ? "#5cb85c" : undefined }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className={`joystix ${active ? "play-options-selected-text" : ""}`} style={{ fontSize: 13 }}>{label}</div>
        <div style={{ fontSize: 12, marginTop: 2, opacity: 0.8, whiteSpace: "normal" }}>{description}</div>
      </div>
      {/*proTag && <span className="label label-warning joystix" style={{ fontSize: 9 }}>Pro</span>*/}
      {active && <Icon name="ok" style={{ color: "#5cb85c", fontSize: 16 }} />}
    </div>
  </button>
);

export default class PlayOptionsModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      count: 10,
      mode: 'multiple_choice',
      skill: 'vocabulary',
    };
  }

  componentDidMount() {
    try {
      const { playOptions } = this.props;

      if(playOptions) {
        let count = playOptions.count || this.state.count;
        let skill = playOptions.skill || this.state.skill;
        let mode = playOptions.mode;

        if(mode !== "text_input" && mode !== "multiple_choice" && mode !== "full_text_input" && mode !== "flashcard") {
          mode = this.state.mode;
        }

        if(!this.props.isPro) {
          count = 10;
          skill = 'vocabulary';
        }
        else if(skill === 'listening' && !this.props.isListeningSkillAvailable) {
          skill = 'vocabulary';
        }
        else if(skill === 'speaking' && !this.isSpeakingSkillAvailable()) {
          skill = 'vocabulary';
        }

        // After the skill corrections above, since availability depends on skill. A
        // stored full_text_input that no longer applies falls back rather than quietly
        // playing a mode the modal isn't showing as selected.
        if(mode === "full_text_input" && !this.isFullTextInputAvailable(skill)) {
          mode = "multiple_choice";
        }
        if(mode === "flashcard" && skill !== "vocabulary") {
          mode = "multiple_choice";
        }

        this.setState({
          count,
          mode,
          skill
        });
      }
    } catch(e) {
      // do nothing
    }
  }

  // full_text_input - typing the whole sentence - is Transcribe with the listening skill
  // and Translate without it. Translate is offered on reviews only: producing a sentence
  // you have never seen is a near-certain fail, which is not what a beginner should meet
  // first. The URL still accepts it either way for anyone who wants it.
  isFullTextInputAvailable(skill = this.state.skill) {
    if(skill === "speaking") {
      return false;
    }
    if(skill === "listening") {
      return true;
    }
    // Behind the translate_reviews experiment - see ExperimentsHelper#translate_reviews?.
    return !!this.props.translateReviewsEnabled && this.props.scope === "ready_for_review";
  }

  fullTextInputLabel(skill = this.state.skill) {
    return skill === "listening" ? "Transcribe" : "Translate";
  }

  // Changing skill can invalidate the mode, so the two move together.
  setSkill(skill) {
    const isFullTextInputDropped = this.state.mode === "full_text_input" && !this.isFullTextInputAvailable(skill);
    const isFlashcardDropped = this.state.mode === "flashcard" && skill !== "vocabulary";
    const mode = isFullTextInputDropped || isFlashcardDropped ? "multiple_choice" : this.state.mode;

    this.setState({ mode, skill });
  }

  isSpeakingSkillAvailable() {
    const localSpeechRecognitionAvailable = window.clozemaster.speechRecognition.isSupported(this.props.targetLanguageIso)
        && window.clozemaster.speechRecognition.isAvailable();

    return this.props.isSpeakingSkillAvailable || localSpeechRecognitionAvailable;
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.count !== this.state.count || prevState.mode !== this.state.mode || prevState.skill !== this.state.skill) {
      this.savePlayOptions();
    }
  }

  savePlayOptions() {
    try {
      window.localStorage.setItem('playOptions', JSON.stringify({
        count: this.state.count,
        mode: this.state.mode,
        skill: this.state.skill
      }));
    } catch(e) {
      // do nothing
    }
  }

  renderCollectionUnit() {
    const { collection, collectionUnitId } = this.props;
    if(!collectionUnitId || !collection.collectionUnits || !collection.collectionUnits.units) return null;
    const units = collection.collectionUnits.units;
    const unitIndex = units.findIndex((u) => u.id === collectionUnitId);
    if(unitIndex === -1) return null;
    const unit = units[unitIndex];
    return <small style={{ display: 'block' }}>Unit {unitIndex + 1}: <strong>{unit.name}</strong></small>;
  }

  renderScope() {
    const { scope } = this.props;
    let content = '';
    if(scope === 'ready_for_review') {
      content = 'Ready for Review';
    }
    else if(scope === 'favorited') {
      content = 'Favorites';
    }
    else if(scope === 'frequency_collections') {
      content = 'Most Common Words';
    }
    else {
      return null;
    }
    return <small className="joystix" style={{ display: 'block' }}>{content}</small>;
  }

  isSkillValid() {
    const { isPro, listeningTrialExpired, speakingTrialExpired } = this.props;
    const { skill } = this.state;

    if(skill === 'listening' && !isPro && listeningTrialExpired) {
      return false;
    }
    if(skill === 'speaking' && !isPro && speakingTrialExpired) {
      return false;
    }
    return true;
  }

  isSubmittable() {
    return this.isSkillValid();
  }

  renderSkillProPromo() {
    const { skill } = this.state;
    const { isPro, listeningTrialExpired, speakingTrialExpired } = this.props;

    if(!isPro && skill === 'listening' && listeningTrialExpired) {
      return (
        <small style={{ display: "block", textAlign: "center", marginTop: 4 }}>
          {listeningTrialExpired && <span className="text-danger">You've already played your one free round for today. </span>}
          {!listeningTrialExpired && 'Play one round of listening for free per day. '}
          <strong><a href="/pro">Get Clozemaster Pro</a></strong> for unlimited listening practice!
        </small>
      );
    }

    if(!isPro && skill === 'speaking' && speakingTrialExpired) {
      return (
        <small style={{ display: "block", textAlign: "center", marginTop: 4 }}>
          {speakingTrialExpired && <span className="text-danger">You've already played your one free round for today. </span>}
          {!speakingTrialExpired && 'Play one round of speaking for free per day. '}
          <strong><a href="/pro">Get Clozemaster Pro</a></strong> for unlimited speaking practice!
        </small>
      );
    }
  }

  renderSkillCards() {
    const { isListeningSkillAvailable, isPro, isSignedIn } = this.props;
    const { skill } = this.state;

    return (
      <div style={{ marginBottom: 15 }}>
        <SkillCard
          active={skill === "vocabulary"}
          description="Read the sentence, fill in the missing word"
          disabled={!isSignedIn}
          icon="eye-open"
          label="Vocabulary"
          onClick={() => this.setSkill("vocabulary")}
        />
        {isListeningSkillAvailable && (
          <SkillCard
            active={skill === "listening"}
            description="Hear the sentence, then fill in the missing word"
            disabled={!isSignedIn}
            icon="headphones"
            label="Listening"
            onClick={() => this.setSkill("listening")}
            proTag={!isPro}
          />
        )}
        {this.isSpeakingSkillAvailable() && (
          <SkillCard
            active={skill === "speaking"}
            description="Read the sentence, speak the missing word"
            disabled={!isSignedIn}
            icon="volume-up"
            label="Speaking"
            onClick={() => this.setSkill("speaking")}
            proTag={!isPro}
          />
        )}
        {this.renderSkillProPromo()}
      </div>
    );
  }

  renderMode() {
    const { skill, mode } = this.state;

    if(skill === "speaking") {
      return null;
    }

    return (
      <div style={{ marginBottom: 15 }}>
        <div style={{ marginBottom: 6 }}><strong>Mode</strong></div>
        <div className="play-options-mode-btns">
          <button
            type="button"
            className="btn btn-default play-options-mode-btn"
            onClick={() => this.setState({ mode: "multiple_choice" })}
            style={{ borderWidth: 2, borderColor: mode === "multiple_choice" ? "#5cb85c" : undefined, position: "relative", background: mode === "multiple_choice" ? "rgba(92, 184, 92, 0.1)" : "none", boxShadow: "none" }}
          >
            {mode === "multiple_choice" && <Icon name="ok" style={{ color: "#5cb85c", position: "absolute", top: 4, right: 6, fontSize: 10 }} />}
              <strong className={mode === "multiple_choice" ? "play-options-selected-text" : ""}>Multiple Choice</strong><br /><span className="label label-success" style={{ fontSize: 9, color: "#000" }}>Easy</span>
          </button>
          {skill === "vocabulary" && (
            <button
              type="button"
              className="btn btn-default play-options-mode-btn"
              onClick={() => this.setState({ mode: "flashcard" })}
              style={{ borderWidth: 2, borderColor: mode === "flashcard" ? "#5cb85c" : undefined, position: "relative", background: mode === "flashcard" ? "rgba(92, 184, 92, 0.1)" : "none", boxShadow: "none" }}
            >
              {mode === "flashcard" && <Icon name="ok" style={{ color: "#5cb85c", position: "absolute", top: 4, right: 6, fontSize: 10 }} />}
              <strong className={mode === "flashcard" ? "play-options-selected-text" : ""}>Flashcards</strong><br /><span className="label label-info" style={{ fontSize: 9, color: "#000" }}>Fast · 1x pts</span>
            </button>
          )}
          <button
            type="button"
            className="btn btn-default play-options-mode-btn"
            onClick={() => this.setState({ mode: "text_input" })}
            style={{ borderWidth: 2, borderColor: mode === "text_input" ? "#5cb85c" : undefined, position: "relative", background: mode === "text_input" ? "rgba(92, 184, 92, 0.1)" : "none", boxShadow: "none" }}
          >
            {mode === "text_input" && <Icon name="ok" style={{ color: "#5cb85c", position: "absolute", top: 4, right: 6, fontSize: 10 }} />}
              <strong className={mode === "text_input" ? "play-options-selected-text" : ""}>Text Input</strong><br /><span className="label label-warning" style={{ fontSize: 9, color: "#000" }}>Hard · 2x pts</span>
          </button>
          {this.isFullTextInputAvailable() && (
            <button
              type="button"
              className="btn btn-default play-options-mode-btn play-options-mode-btn-transcribe"
              onClick={() => this.setState({ mode: "full_text_input" })}
              style={{ borderWidth: 2, borderColor: mode === "full_text_input" ? "#5cb85c" : undefined, position: "relative", background: mode === "full_text_input" ? "rgba(92, 184, 92, 0.1)" : "none", boxShadow: "none" }}
            >
              {mode === "full_text_input" && <Icon name="ok" style={{ color: "#5cb85c", position: "absolute", top: 4, right: 6, fontSize: 10 }} />}
              <strong className={mode === "full_text_input" ? "play-options-selected-text" : ""}>{this.fullTextInputLabel()}</strong><br /><span className="label label-danger" style={{ fontSize: 9, color: "#000" }}>Harder · 2x pts</span>
            </button>
          )}
        </div>
      </div>
    );
  }

  renderSentencesPerRound() {
    const { count } = this.state;
    const { isPro } = this.props;

    return (
      <div style={{ marginBottom: 15 }}>
        <div style={{ marginBottom: 6 }}><strong>Sentences per round</strong></div>
        <select className="form-control" name="count" value={count} onChange={(e) => this.setState({ count: e.target.value })}>
          {[1, 5, 10, 20, 30, 40, 50, 100, 'Infinite'].map((n) => <option key={n} disabled={!isPro && n !== 10} value={n.toString().toLowerCase()}>{n}</option>)}
        </select>
        {!isPro && <small style={{ display: "block", textAlign: "center", marginTop: 4 }}><strong><a href="/pro">Get Clozemaster Pro</a></strong> to change the number of sentences per round!</small>}
      </div>
    );
  }

  render() {
    const { onHidden, collection } = this.props;
    const { mode, skill } = this.state;

    return (
      <Modal onHidden={onHidden} title="Play Options">
        <div style={{ marginBottom: 15 }}>
          <span style={{ fontSize: 20, fontWeight: "bold" }}>{collection.name}</span>
          {this.renderScope()}
          {this.renderCollectionUnit()}
        </div>
        <p>How do you want to practice today?</p>
        <form method="get" action={collection.playWebUrl}>
          <input type="hidden" name="scope" value={this.props.scope || ''} />
          <input type="hidden" name="collection_unit_id" value={this.props.collectionUnitId || ''} />
          <input type="hidden" name="skill" value={skill} />
          <input type="hidden" name="mode" value={mode} />
          {this.renderSkillCards()}
          {this.renderMode()}
          {this.renderSentencesPerRound()}
          <button disabled={!this.isSubmittable()} className="btn btn-block btn-lg joystix btn-success" style={{ marginTop: 20 }}>
            Play <span className="glyphicon glyphicon-chevron-right"></span>
          </button>
        </form>
      </Modal>
    );
  }
}
